import { Reveal } from "./Reveal";
import { ABOUT_CHAPTERS } from "@/data/content";
import { ABOUT_CHAPTERS_AR, UI } from "@/i18n/copy";
import { useLang } from "@/i18n/LanguageContext";

export const About = () => {
  const { lang } = useLang();
  const t = UI[lang].about;
  const chapters = lang === "ar" ? ABOUT_CHAPTERS_AR : ABOUT_CHAPTERS;

  return (
    <section id="about" data-testid="about-section" className="scroll-mt-20 bg-white">
      <div className="mx-auto grid max-w-7xl gap-16 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-[1fr_1.4fr]">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <Reveal>
            <p className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-black/50">
              {t.eyebrow}
            </p>
            <h2 className="mt-6 text-4xl font-black uppercase leading-[1] tracking-tight text-black sm:text-5xl lg:text-6xl">
              {t.headingA}{" "}
              {lang === "en" ? (
                <span className="font-script text-[1.3em] normal-case leading-none tracking-normal">{t.accent}</span>
              ) : (
                t.accent
              )}{" "}
              {t.headingB}
            </h2>
            <p className="mt-8 max-w-sm text-base leading-relaxed text-black/55">{t.side}</p>
          </Reveal>
        </div>

        <div className="divide-y divide-black/10 border-y border-black/10">
          {chapters.map((ch, i) => (
            <Reveal key={ch.num} delay={i * 0.1}>
              <article className="group grid gap-4 py-10 sm:grid-cols-[90px_1fr] sm:gap-8" data-testid={`manifesto-chapter-${ch.num}`}>
                <span className="font-mono-label text-sm font-medium text-black/35 transition-colors duration-300 group-hover:text-black">
                  /{ch.num}
                </span>
                <div>
                  <h3 className="text-2xl font-bold tracking-tight text-black sm:text-3xl">{ch.title}</h3>
                  <p className="mt-4 text-base leading-relaxed text-black/60">{ch.body}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
